export const SET_STATE = 'checkoutPage/vehicleRentalTsAndCs/SET_STATE';
export const SET_FETCHING = 'checkoutPage/vehicleRentalTsAndCs/SET_FETCHING';
export const SET_TS_AND_CS = 'checkoutPage/vehicleRentalTsAndCs/SET_TS_AND_CS';
export const SET_TS_AND_CS_FOR_PRODUCT_TOKEN = 'checkoutPage/vehicleRentalTsAndCs/SET_TS_AND_CS_FOR_PRODUCT_TOKEN';
export const RESET_STATE = 'checkoutPage/vehicleRentalTsAndCs/RESET_STATE';
